import { Venue } from './venue';

export class Pitch {
    type = 'pitches';
    id: number | null;
    attributes: {
        name: string,
        images: {
            small: Array<string>,
            medium: Array<string>,
            large: Array<string>
        },
        sport: string,
        surface: string,
        format: string
    };
    relationships: {
        venues: {
            data: Venue
        }
    };
    links: {
        weblink: string
    };
}
